class FetchMessagesQuery {

    constructor(pageSize = 30, anchor, direction = "backwards" ) {
        this.pageSize=pageSize;
        this.anchor=anchor
        this.direction=direction
    }
}

export default FetchMessagesQuery;



// WEBPACK FOOTER //
// ./src/platform/chat/model/FetchMessagesQuery.js